<script setup lang="ts">
import Modal from '~/components/modals/Modal.vue';
import { MODAL_REVIEW_RULES } from '~/store/modalStore';

const props = defineProps<{
  isModalVisible: boolean
  closeModal: () => void
}>()

const {
  isModalVisible,
  closeModal,
} = toRefs(props)
</script>

<template>
  <Modal
         :id="MODAL_REVIEW_RULES"
         :is-visible="isModalVisible"
         :title="$t('www.product_availability.modal.title')"
         @close="closeModal">
    <div class="mb-1">{{ $t('www.reviews.rules.subtext') }}</div>
    <a :href="$customLocalePath('www_reviewModeraion')" target="_blank" class="underline-text mb-1">{{ $t('www.reviews.rules.see-more') }}</a>
  </Modal>
</template>
